import CountCell from 'components/CountCell';
import type { ManagedOemSegmentType } from '../..';

interface CellProps {
  rowData: ManagedOemSegmentType;
}

export default function TeamsCountCell({ rowData: { id, totals } }: CellProps) {
  return (
    <CountCell
      count={totals?.sentinelTeams}
      pageParams={{
        tab: 'teams',
        oemSegmentIds: [id],
        teamIds: [],
        accountIds: [],
        depotIds: [],
      }}
    />
  );
}
